import { z } from "zod";

import { ALL_MODES, type Mode } from "../../../components/widget-form/thresholds/settings";
import { Encoder } from "../../_encoder";

const decoder = z.enum(ALL_MODES).optional().catch(undefined);

function encoder(mode: undefined | Mode, defaults: Mode): Encoder {
	return Encoder.primitive(mode, defaults);
}

export { decoder, encoder };
